import ComText from '../components/text'
import ComMainTitle from '../components/main-title'
import ComSubTitle from '../components/sub-title'
import ComBlockQuote from '../components/blockquote'
import ComOrderLine from '../components/order-line'
import ComUnorderLine from '../components/unorder-line'
import ComLine from '../components/line'
import ComImg from '../components/img'
import ComImgDesc from '../components/img-desc'
import ComIframe from '../components/iframe'
import ComOriginSource from '../components/origin-source'
import ComNewsSource from '../components/news-source'

class BaseDelegate {
  article
  handlers = {}
  store = {}
  constructor (base_list) {
    base_list.forEach(({name, formatData}) => {
      this.handlers[name] = formatData
    });
  }

  setArticle (article) {
    this.article = article
    this.store = {}
    return this
  }

  handle (type, dom) {
    if (this.handlers[type]) {
      return this.handlers[type](dom, this.article, this.store)
    } else {
      console.warn(`[@heybox-components/hb-article] ${type}类型未处理`)
      return false
    }
  } 

  setHandler (type, formatData) {
    this.handlers[type, formatData]
  }
}

export const DEFAULT_BASE_DELEGATE = new BaseDelegate(
  [
    ComText,
    ComMainTitle,
    ComSubTitle,
    ComBlockQuote,
    ComOrderLine,
    ComUnorderLine,
    ComLine,
    ComImg,
    ComImgDesc,
    ComIframe,
    ComOriginSource,
    ComNewsSource
  ]
)

export default BaseDelegate